module.exports = __webpack_public_path__ + "static/media/tyme-bank-personal-loan.f5fe7907.svg";